





















































	import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
	import AdminContentRow from './admin-content/AdminContentRow.vue';   
    import { TextPermission, AppSettings, HellospokeUser, store, StoreState } from '../../store';
    import { mapState } from 'vuex'; 
    import axios from 'axios'; 
    import VueElementLoading from 'vue-element-loading';
	import {RotateSquare2} from 'vue-loading-spinner';        
	
	declare interface AdminContentData { 
		search_results: HellospokeUser[];    
		search_termadmin: string;
		feedback_text: string;
		savedisable:false;
		feedback_error: boolean;
		loading:boolean;
	}

	@Component({
		components: {
			AdminContentRow, RotateSquare2,VueElementLoading
        },
        computed: {
			...mapState({
				'selectedAccount': (state: StoreState) => state.dashboard.admin.selectedAccount, //admin_loader
				'comapany_name':  (state: StoreState) => state.dashboard.admin.company_name,
				'admin_loader' :(state: StoreState) => state.dashboard.admin.admin_loader
			})
		}
	})
	export default class AdminContent extends Vue {
        selectedAccount!: object;
		mounted() {
			this.search();
		}

		data() {
			return {
				search_results: [],
				search_termadmin: "",
				feedback_text: "",
				feedback_error: false,
				savedisable:false,
				loading:false,
                allcallrecord:'',
                upade_admin:[],
                not_upade_admin:[]
			} as AdminContentData
		}

		@Prop()
		public users!: HellospokeUser[];

		get isDisabled(){
			return false;
		}
        search_inputclick()
        {
            var x = document.getElementById("input_searchiconadmincontent");
            x.style.display = "none";
        }

        search_inputblur()
        {
            var x = document.getElementById("input_searchiconadmincontent");
            if(this.$data.search_termadmin.length!=0){
            x.style.display = "none";
            }
            else{
            x.style.display = "inline";
            }
        }
            
        focusInput() 
        { 
                document.getElementById("input_search_admin").focus(); 
                var x = document.getElementById("input_searchiconadmincontent");
                x.style.display = "none";
        } 
		all_callrecordchange(value: any){  
            this.$data.allcallrecord=value;
		}

        change_callrecordingExternal(value){  
		    this.$props.users.forEach(element => {
                       element.callrecord_internal =element.callrecord_external =value//false;
                       element.update_status=true;
              });
		}  
		

		change_callrecordingInternal(value){
            this.$props.users.forEach(element => {
                       element.callrecord_internal =element.callrecord_external=value// false;
                       element.update_status=true;
              });
		}

		search() {
			this.$data.search_results = this.$props.users.filter((user: any) => {
				return (
					(user.first_name || '').toLowerCase().includes(this.$data.search_termadmin.toLowerCase()) ||
					(user.last_name || '').toLowerCase().includes(this.$data.search_termadmin.toLowerCase()) ||
					(user.presence_id || '').includes(this.$data.search_termadmin.toLowerCase())
				);
            });
		}

        async save() {
			//Checking data before sending.
			//Right now just does basic checks for managers, will probably want more
            //data consistency checks later on.
            const acc_id= typeof (this.selectedAccount as any).id != 'undefined' ? (this.selectedAccount as any).id: this.selectedAccount;
            const payload = {
                account_id: acc_id,  
                users: null
            };
         //  let users_clone = JSON.parse(JSON.stringify(this.$props.users));
           this.$data.feedback_text = "";
            this.$data.upade_admin=[];
             this.$data.not_upade_admin=[];
            
              this.$props.users.forEach(element => {
                if(element.update_status==true)
                {
                //  this.$data.upade_admin.push( JSON.parse(JSON.stringify(element))) ;
                     this.$data.upade_admin.push( (element));
                }
                else
                {
                    this.$data.not_upade_admin.push( (element));
                }
              });
            
           let users_clone = JSON.parse(JSON.stringify(this.$data.upade_admin));
          // console.log(JSON.stringify(users_clone))
           let users_clone_not_update = JSON.parse(JSON.stringify(  this.$data.not_upade_admin));
           let updated_managers= [];
            if(users_clone.length!=0)  
            this.$data.loading=users_clone.length>0 ?true:false;
             this.$store.commit('SET_ADMIN_LOADER',this.$data.loading);//
           // const len = this.$props.users.length;
            for(const user of users_clone) {
                // This will get reevaluated when getting assigned managers
               // user.assigned_users = [];
                delete user.original_managers;
            }
			for(const user of users_clone) {
                let final_tp = [];
                for(const number of user.text_permissions) {
                    if(number.text_permissions_level !== "unset") {
                        final_tp.push((number as never));
                    }
                }
				user.text_permissions = final_tp;
                //user.callrecord_internal = user.callrecord_external = true;
                
                //check Manager 
                user.assigned_managers.forEach(manager => {
                    if(manager && manager!== "remove-manager" && manager!== "none" && !this.checkManager(user, manager)) {
                        this.$data.feedback_text =
                        `Error: User ${user.first_name} ${user.last_name}\'s manager
                        ${manager.first_name} ${manager.last_name} has an incorrect role.`;
                        this.$data.feedback_error = true;
                        this.$data.loading=false;
                        return;
                    }
                });
                if(user.assigned_managers.length > 0) {
                      user.assigned_managers = user.assigned_managers.filter(function(manager, index, arr){
                                          return !( manager === "remove-manager" ||manager === "none" || manager===null);
                             });;

                    // For adding user to assigned_users list of manager 
                    for(let i = 0; i < user.assigned_managers.length; i++) {
                        const manager_id = user.assigned_managers[i]._id;
                        let manager = users_clone.find((e: any) => {
                            return e._id === manager_id;
                        });
                        var addmanagertoupdateuserlist= false;
                        if(typeof manager === "undefined") {
                                manager = users_clone_not_update.find((e: any) => {
                                return e._id === manager_id;
                            });
                            addmanagertoupdateuserlist=true;
                        }
                        if (typeof manager.assigned_users === "undefined") 
                             manager.assigned_users=[];
                        var asigneduser= manager.assigned_users.find((e: any) => {
                                return e === user._id;
                            });
                        if (typeof asigneduser  === "undefined")
                               manager.assigned_users.push(user._id);   
                        if (addmanagertoupdateuserlist )
                        {
                            var manager_assigned_managers=[];
                            manager.assigned_managers.forEach(element => {
                                const assigned_manager_id= element._id;
                                manager_assigned_managers.push(assigned_manager_id);
                            });
                            if (manager_assigned_managers.length>0)
                            {
                                delete manager.assigned_managers;
                                manager.assigned_managers=manager_assigned_managers;
                            }
                            updated_managers.push(manager);
                        }
                        user.assigned_managers[i] = manager_id;
                    }
                    //below code is for removing assigned_users from manager 
                    users_clone_not_update.forEach(element => {
                        var  manager = user.assigned_managers.find((e: any) => {
                                return e === element._id;
                            });
                        if (typeof manager === "undefined")
                        {
                            if (typeof element.assigned_users === "undefined")  element.assigned_users=[];
                            var  assigned_users_length= element.assigned_users.length;
                            element.assigned_users = element.assigned_users.filter(function(value, index, arr){
                                          return user._id != value;
                             });;
                             if (assigned_users_length!= element.assigned_users.length)
                             {
                                var tmpmnger= updated_managers.find((e: any) => {
                                    return e === element;
                                });
                                if (typeof tmpmnger === "undefined")
                                    updated_managers.push(element);
                             }
                        }
                    });
                     users_clone.forEach(element => {
                        var  manager = user.assigned_managers.find((e: any) => {
                                return e === element._id;
                            });
                        if (typeof element.assigned_users === "undefined") element.assigned_users=[];
                        if (typeof manager === "undefined")
                        {
                          element.assigned_users = element.assigned_users.filter(function(value, index, arr){
                                          return user._id != value;
                             });;
                        }
                    });
                   //end reoving assigned_users code
                }
            }
            users_clone.push(...updated_managers);
			payload.users =  users_clone;
            const response = await this.updateUsers(payload);
            console.log(JSON.stringify(response))
             //  this.$props.users= users_clone;
            this.$emit("refresh", response);  
            this.$data.loading=false;
            this.$store.dispatch('getTextPermissions'); 
             this.$store.commit('SET_ADMIN_LOADER',false);//
			this.$data.feedback_text = "Settings saved.";
			this.$data.savedisable =false;
			this.$data.feedback_error = false;
        }

		
        
        @Watch('users')
        onUsersChange() {
            this.search();
        }

		async updateUsers(payload: any) 
		{
            console.log(JSON.stringify(payload))
			this.$data.feedback_text ="";
			this.$data.savedisable =true;
            
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.account.jwt;
            const r = await axios.put(`${AppSettings.API_HOST}updateUsers`, {payload: payload});
            return r.data;
        }

		checkManager(user: any, manager: any)
		{
			if(user.priv_level === "admin" || user.priv_level === "voitress-admin") {
				return false
			}
			else if(user.priv_level === "manager" &&
				(
					manager.priv_level !== "admin" &&
					manager.priv_level !== "voitress-admin"
				)
			) {
				return false;
			}
			else if(manager.priv_level === "user") {
				return false;
			}
			return true;
		}

	}
